import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import CampaignCreate from './campaign-create/campaign-create';
import CampaignLaunch from './campaign-launch/campaign-launch';
import CampaignTemplate from './campaign-template/campaign-template';

export default class Campaign extends Component {
	render() {	
        const { match, isPackageFetched } = this.props;
		return (
            <Switch>
                <Route 
                    path={`${match.path}/`} 
                    exact 
                    render={(props) => (
                        <CampaignTemplate 
                            {...props} 
                            isPackageFetched={isPackageFetched} 
                        />
                    )}
                />
                <Route 
                    path={`${match.path}/launch/:simulationType/:attackType/:ch`} 
                    exact 
                    render={(props) => (
                        <CampaignLaunch 
                            {...props} 
                            isPackageFetched={isPackageFetched} 
                        />
                    )}
                />
                <Route path={`${match.path}/:id`} exact component={ CampaignCreate }/>
                <Route render={() => (<Redirect to="/invalid" />)}/>
            </Switch>
		);
	}
}